var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.951,49.962c-0.49,-0.38 -4.527,-3.542 -8.427,-7.515c-4.378,-4.46 -8.78,-12.335 -8.78,-12.335l0.001,0c-1.745,-2.968 -2.745,-6.424 -2.745,-10.112c0,-11.038 8.962,-20 20,-20l0.129,0c10.979,0.07 19.871,9.005 19.871,20c0,3.688 -1,7.144 -2.745,10.112l0.001,0c0,0 -4.402,7.875 -8.78,12.335c-4.16,4.238 -8.476,7.553 -8.476,7.553l-0.049,-0.038Z",
    style: {
      fill: "rgb(0,149,109)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.951,49.962c-0.49,-0.38 -4.527,-3.542 -8.427,-7.515c-4.378,-4.46 -8.78,-12.335 -8.78,-12.335l0.001,0c-1.745,-2.968 -2.745,-6.424 -2.745,-10.112c0,-11.038 8.962,-20 20,-20l0.129,0c10.979,0.07 19.871,9.005 19.871,20c0,3.688 -1,7.144 -2.745,10.112l0.001,0c0,0 -4.402,7.875 -8.78,12.335c-4.16,4.238 -8.476,7.553 -8.476,7.553l-0.049,-0.038Zm15.559,-20.825l0.021,-0.038c1.57,-2.671 2.469,-5.781 2.469,-9.099c0,-9.896 -8.003,-17.937 -17.877,-18c0,0 -0.129,0 -0.123,0c-9.934,0 -18,8.066 -18,18c0,3.318 0.899,6.428 2.469,9.099l0.021,0.037c0,0 4.237,7.607 8.461,11.91c2.718,2.768 5.503,5.133 7.049,6.395c1.543,-1.26 4.33,-3.625 7.049,-6.395c4.224,-4.303 8.461,-11.91 8.461,-11.91l0,0.001Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.0849626,-2.1753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.57,25.387l5.724,5.133l10.966,-16.69",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: 4
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassMarker);
export default __webpack_public_path__ + "static/media/passMarker.c439176b9827ef70ef7b9abc2221b6f3.svg";
export { ForwardRef as ReactComponent };